<template>
  <a-card :bordered="false" title="用户列表" :headStyle="{fontSize:'18px'}">
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="searchItemList"
      :columns="columns"
      :queryParams="queryParams"
      requestType="get"
      :leftSpace="10"
      :requestPromise="getUserList"
    >
      <a-form-item slot="search_nickName" label="微信昵称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.nickName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_mobileNo" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobileNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_source" label="来源" v-bind="searchItemLayout">
        <a-input v-model="queryParams.source" placeholder="请输入"></a-input>
      </a-form-item>
      <span slot="avatarUrl" slot-scope="rowItem">
        <img v-if="rowItem.record.avatarUrl" :src="rowItem.text" class="head-picture">
        <img v-else src="../../assets/personla.png" class="head-picture">
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="toDetail(rowItem.record)">查看详情</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../utils/mixins/searchFormMixins'

export default {
  name: 'UserList',
  mixins: [searchForm],
  data() {
    return {
      searchItemList: ['search_nickName', 'search_mobileNo', 'search_source'],
      queryParams: {},
      columns: [
        {
          title: 'ID',
          dataIndex: 'memberId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName'
        },
        {
          title: '头像',
          dataIndex: 'avatarUrl',
          scopedSlots: { customRender: 'avatarUrl' }
        },
        {
          title: '手机号',
          dataIndex: 'mobileNo'
        },
        {
          title: '累计订单',
          dataIndex: 'totalOrderNum'
        },
        {
          title: '累计消费金额（元）',
          dataIndex: 'totalAmount'
        },
        {
          title: '来源',
          dataIndex: 'source'
        },
        {
          title: '最近访问',
          dataIndex: 'lastLoginTimeStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    toDetail(record) {
      this.$router.push({
        name: 'UserDetail',
        query: { memberId: record.memberId }
      })
    },
    getUserList(params) {
      return this.getHttpServices().getUserService().get('api/v2/member/list', params)
    }
  }
}
</script>

<style scoped>
.head-picture {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: none;
}
</style>
